import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";

import { PageStatus } from "../../types/pagination";

@Component({
    selector: "sps-pagination",
    templateUrl: "./sps-pagination.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsPaginationComponent implements OnChanges {
    static readonly displayName = "sps-pagination";
    static readonly props = {
        page: "number",
        pageSizeOptions: "Array<number>",
        pageSize: "number",
        totalResults: "number",
        change: { event: true, type: "PageStatus" },
    };

    @HostBinding("class.sps-pagination") readonly _spsPaginationClass = true;

    @Input() page = 1;
    @Input() pageSizeOptions = [25, 50, 100];
    @Input() pageSize = this.pageSizeOptions[0];
    @Input() totalResults = 0;

    @Output() change = new EventEmitter<PageStatus>();

    get totalResultsText() {
        return typeof this.totalResults === undefined
            ? "many"
            : this.totalResults;
    }

    get numPages() {
        return Math.ceil(this.totalResults / this.pageSize);
    }

    get resultsVisible() {
        return this.numPages === 0
            ? 0
            : this.page === this.numPages
                ? this.totalResults % this.pageSize || this.pageSize
                : this.pageSize;
    }

    get pageIndexRange(): [number, number] {
        const start = (this.page - 1) * this.pageSize;
        return this.numPages === 0
         ? [0, 0]
         : [start + 1, start + this.resultsVisible];
    }

    constructor(private _changeDetector: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.page) {
            this.setPage(changes.page.currentValue);
        }

        if (changes.pageSizeOptions) {
            if (this.pageSizeOptions.indexOf(this.pageSize) === -1) {
                this.pageSize = this.pageSizeOptions[0];
            }
        }
    }

    setPage(newPage: number) {
        if (!newPage || newPage < 1) {
            this.page = 1;
        } else if (newPage > this.numPages) {
            this.page = this.numPages;
        } else {
            this.page = newPage;
        }
        this._changeDetector.markForCheck();
    }

    _onPageSizeChange() {
        this.setPage(1);
        this._emitChange();
    }

    _emitChange() {
        this.change.emit({
            page: this.page,
            pageSize: this.pageSize,
            indices: this.pageIndexRange,
        });
    }
}
